<template>
    <div class="list-group">
        <template v-if="reports.length > 0">
            <div v-for="date in Object.keys(reportsData)" :key="date" class="list-group-item p-0">
                <button type="button" class="list-group-item-action p-3" @click.prevent="activeDate = date">
                    <span :class="['bi', activeDate === date ? 'bi-chevron-up' : 'bi-chevron-down']"></span>
                    {{ date }}
                    ({{ reportsData[date].user }})
                </button>
                <div class="collapse" :class="{'show': activeDate === date}">
                    <ICodeReportsTable :reports="reportsData[date].reports" v-model="activeReportsIds" />
                </div>
            </div>
        </template>
        <div v-else class="alert alert-info">
            {{ $t('No reports found related to this serial number') }}
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, type PropType } from "vue";
import {trans as $t} from "@/vue/composables/missingTranslations";
import useDates from "@/vue/composables/useDates";
import ICodeReportsTable from "@/vue/connect/icode/ICodeReportsTable.vue";
import { type ReportType } from "@/vue/types/report";

const activeReportsIds = defineModel<number[]>({ required: true });
const activeDate = defineModel<string>('activeDate', { required: true });
const props = defineProps({
    reports: {
        type: Array as PropType<ReportType[]>,
        default: () => [],
    },
});

const { getFormattedDate } = useDates('MM-DD-YYYY HH:mm');

const reportsData = computed(() => {
    const data: Record<
        string,
        { reports: ReportType[], user: string|null }
    > = {};

    props.reports.forEach((report) => {
        const date = getFormattedDate(report.created);

        if (data[date]) {
            data[date].reports.push(report);
        } else {
            data[date] = {
                reports: [report],
                user: report.laravel_user
                    ? `${report.laravel_user.staff?.last_name}, ${report.laravel_user.staff?.first_name}`|| report.laravel_user.name || report.laravel_user.email
                    : $t('Legacy system'),
            };
        }
    });

    return data;
});
</script>
